
    import './styles.scoped.css';
    export default {
  "visible-content": "awsui_visible-content_tc96w_llj89_185",
  "visible-content-toggle": "awsui_visible-content-toggle_tc96w_llj89_186",
  "visible-content-groups": "awsui_visible-content-groups_tc96w_llj89_187",
  "visible-content-group": "awsui_visible-content-group_tc96w_llj89_187",
  "visible-content-title": "awsui_visible-content-title_tc96w_llj89_192",
  "visible-content-group-label": "awsui_visible-content-group-label_tc96w_llj89_201",
  "visible-content-option": "awsui_visible-content-option_tc96w_llj89_207",
  "visible-content-option-label": "awsui_visible-content-option-label_tc96w_llj89_218",
  "content-display-option-toggle": "awsui_content-display-option-toggle_tc96w_llj89_409",
  "content-display-option-content": "awsui_content-display-option-content_tc96w_llj89_413",
  "content-display-option": "awsui_content-display-option_tc96w_llj89_409",
  "placeholder": "awsui_placeholder_tc96w_llj89_458",
  "sorting": "awsui_sorting_tc96w_llj89_458",
  "content-display-option-label": "awsui_content-display-option-label_tc96w_llj89_485",
  "drag-overlay": "awsui_drag-overlay_tc96w_llj89_492",
  "content-display": "awsui_content-display_tc96w_llj89_409",
  "content-display-title": "awsui_content-display-title_tc96w_llj89_519",
  "content-display-description": "awsui_content-display-description_tc96w_llj89_527",
  "content-display-option-list": "awsui_content-display-option-list_tc96w_llj89_535",
  "root": "awsui_root_tc96w_llj89_541",
  "modal-root": "awsui_modal-root_tc96w_llj89_542",
  "trigger-button": "awsui_trigger-button_tc96w_llj89_543",
  "cancel-button": "awsui_cancel-button_tc96w_llj89_544",
  "confirm-button": "awsui_confirm-button_tc96w_llj89_545",
  "custom": "awsui_custom_tc96w_llj89_546",
  "second-column-small": "awsui_second-column-small_tc96w_llj89_550",
  "wrap-lines": "awsui_wrap-lines_tc96w_llj89_554",
  "striped-rows": "awsui_striped-rows_tc96w_llj89_555",
  "content-density": "awsui_content-density_tc96w_llj89_556",
  "page-size": "awsui_page-size_tc96w_llj89_557",
  "page-size-form-field": "awsui_page-size-form-field_tc96w_llj89_558",
  "page-size-radio-group": "awsui_page-size-radio-group_tc96w_llj89_559",
  "sticky-columns": "awsui_sticky-columns_tc96w_llj89_560",
  "sticky-columns-form-field": "awsui_sticky-columns-form-field_tc96w_llj89_561",
  "sticky-columns-radio-group": "awsui_sticky-columns-radio-group_tc96w_llj89_562",
  "sticky-columns-first": "awsui_sticky-columns-first_tc96w_llj89_563",
  "sticky-columns-last": "awsui_sticky-columns-last_tc96w_llj89_564"
};
  